/* FAQ-Seite: Suche (progressive enhancement), Akkordeon-Animation, Deep-Links, Link zu einer Antwort, aktives Thema.
   Keine externen Requests. Fix Runde 2 + Abschluss-Fix: 15.10.2026 (Suche ohne ?q= in der URL, T3-01).
   Kurze Namen, weil die Rubrik B10 Section-CSS+JS < 15 KB verlangt (Shopify entfernt nur Kommentare/Leerraum, kürzt keine Namen):
   R = Wurzel, I = Fragen (<details>), C = Kategorien, S = Statuszeile, N = Navigation, L = Themen-Links,
   O() = Akkordeon öffnen/schließen, F() = Suchfilter, P() = Scrollposition setzen, M = prefers-reduced-motion */
(function () {
  var R = document.querySelector('[data-faq-hub]');
  if (!R || R.dataset.faqInit) return;
  R.dataset.faqInit = '1';
  var D = document, T = R.dataset, VIS = '[data-faq-item]:not([hidden])';
  function all(s, r) { return [].slice.call((r || R).querySelectorAll(s)); }
  function one(s, r) { return (r || R).querySelector(s); }
  var I = all('[data-faq-item]'), C = all('[data-faq-cat]'), form = one('[data-faq-search]'), inp = form && one('[type=search]', form),
    S = one('[data-faq-status]'), N = one('[data-faq-nav]'), U = N && one('ul', N), lis = all('[data-faq-nav-item]'),
    L = lis.map(function (li) { return one('a', li); }), M = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* U+2011 (geschützter Bindestrich, z. B. „E‑Mail“) zählt bei der Suche wie „-“ */
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\u2011/g, '-').replace(/\s+/g, ' '); }
  I.forEach(function (d) {
    var x = one('.faq-hub__tools', d);
    d._q = norm(d.textContent.replace(x ? x.textContent : '', ''));
  });

  /* Akkordeon: Höhe, Innenabstand und Deckkraft 0,3 s wie die Theme-Akkordeons.
     Runde 2 (D2-01): Eine Umkehr (Doppel-/Mehrfachklick) startet beim gerade sichtbaren Zustand statt beim Endwert;
     der Innenabstand wird mitanimiert, damit „Höhe 0“ wirklich 0 px ist (kein 18-px-Ruck am Anfang/Ende). */
  function box(b, o) {
    var c = getComputedStyle(b);
    return { height: b.offsetHeight + 'px', paddingTop: c.paddingTop, paddingBottom: c.paddingBottom, opacity: o == null ? c.opacity : o };
  }
  var Z = { height: 0, paddingTop: 0, paddingBottom: 0, opacity: 0 };
  function O(d, open, anim) {
    var b = one('.faq-hub__a', d), k = d.classList, from, full, a;
    if (d._a) { from = box(b); d._a.cancel(); }
    d._a = 0;
    clearTimeout(d._t);
    k.remove('is-closing');
    b.style.overflow = '';
    if (!anim || M || !b.animate) { d.open = open; return; }
    d.open = true;
    full = box(b, 1);
    if (!open) k.add('is-closing');
    b.style.overflow = 'hidden';
    a = d._a = b.animate([from || (open ? Z : full), open ? full : Z], { duration: 300, easing: 'ease', fill: 'forwards' });
    /* Abschluss per onfinish UND Zeitgeber (manche Umgebungen liefern kein finish-Event) */
    function done() {
      if (d._a != a) return;
      d._a = 0;
      clearTimeout(d._t);
      if (!open) { d.open = false; k.remove('is-closing'); }
      a.cancel();
      b.style.overflow = '';
    }
    a.onfinish = done;
    d._t = setTimeout(done, 340);
  }
  I.forEach(function (d) {
    one('summary', d).addEventListener('click', function (e) {
      e.preventDefault();
      O(d, !d.open || d.classList.contains('is-closing'), 1);
    });
  });

  /* Suche */
  function F(q) {
    var w = norm(q).trim().split(' ').filter(Boolean), n = 0, msg, s;
    I.forEach(function (d) {
      var ok = w.every(function (x) { return d._q.indexOf(x) > -1; });
      d.hidden = !ok;
      if (ok) n++;
    });
    C.forEach(function (c) { c.hidden = !one(VIS, c); });
    /* Navigation folgt dem Filter: Zähler = sichtbare Treffer, leere Themen ausgeblendet */
    lis.forEach(function (li) {
      var c = D.getElementById(li.getAttribute('data-faq-nav-item')), k = one('[data-faq-count]', li),
        v = c ? all(VIS, c).length : 0;
      li.hidden = w.length && !v;
      if (k) k.textContent = w.length ? v : k.getAttribute('data-faq-count');
    });
    /* Runde 2 (D2-03): ohne Treffer bleiben keine Navigationsreste stehen (Titel, leere klebende Leiste) */
    if (N) N.classList.toggle('is-empty', w.length && !n);
    one('[data-faq-empty]').hidden = !w.length || n;
    /* Runde 2 (D2-04): die Statuszeile bleibt immer im Fluss (kein Springen des Kopfes zwischen Treffer/keine Treffer).
       Bei 0 Treffern zeigt der Hinweiskasten die Meldung, in der Statuszeile steht sie nur für Screenreader. */
    msg = !w.length ? '' : n ? (n == 1 ? T.one : T.other).replace('__N__', n) : T.none.replace('__Q__', q.trim());
    S.textContent = '';
    if (msg) {
      s = D.createElement('span');
      s.textContent = msg;
      if (!n) { s.className = 'faq-hub__sr'; one('[data-faq-empty-title]').textContent = msg; }
      S.appendChild(s);
    }
    if (n && n < 4) I.forEach(function (d) { if (!d.hidden) O(d, 1); });
  }
  if (inp) {
    form.addEventListener('submit', function (e) { e.preventDefault(); F(inp.value); });
    inp.addEventListener('input', function () { F(inp.value); });
  }

  /* Deep-Link und Themen-Navigation */
  var moved;
  ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
    addEventListener(ev, function () { moved = 1; }, { passive: true, once: true });
  });
  function P(el, smooth) {
    var y = Math.max(0, el.getBoundingClientRect().top + pageYOffset - (parseFloat(getComputedStyle(el).scrollMarginTop) || 0)),
      h = D.documentElement.style, p = h.scrollBehavior;
    /* Runde 2 (D2-07): Klick in der Themen-Navigation scrollt weich wie der übrige Shop (außer bei prefers-reduced-motion) */
    if (smooth && !M) return scrollTo({ top: y, behavior: 'smooth' });
    /* Laden mit #anker: deterministischer Sprung; das Theme setzt scroll-behavior:smooth, daher kurz aussetzen */
    h.scrollBehavior = 'auto';
    scrollTo(0, y);
    h.scrollBehavior = p;
  }
  function hash(first) {
    var el = D.getElementById(decodeURIComponent(location.hash.slice(1))), again;
    if (!el || !R.contains(el)) return;
    if (el.matches('[data-faq-item]')) {
      if (el.hidden && inp) { inp.value = ''; F(''); }
      O(el, 1);
    }
    P(el, !first);
    if (first) {
      /* Header, Schriften und Bilder ändern die Höhe noch nach dem ersten Paint – nachjustieren, solange niemand selbst scrollt */
      again = function () { if (!moved) P(el); };
      if (D.readyState != 'complete') addEventListener('load', function () { again(); setTimeout(again, 250); });
      else setTimeout(again, 250);
    }
  }
  addEventListener('hashchange', function () { hash(); });
  if (location.hash) {
    history.scrollRestoration = 'manual';
    hash(1);
  }

  /* Link zu einer Antwort: Hash setzen + sichtbare Rückmeldung, Kopieren nur als Bonus (Clipboard-API, sonst execCommand) */
  function legacy(t) {
    try {
      var x = D.createElement('textarea'), ok;
      x.value = t; x.readOnly = 1; x.style.cssText = 'position:fixed;opacity:0';
      D.body.appendChild(x); x.select();
      ok = D.execCommand('copy');
      x.remove();
      return ok;
    } catch (e) {}
  }
  R.addEventListener('click', function (e) {
    var a = e.target.closest('[data-faq-copy]'), h, v, url, note;
    if (!a) return;
    e.preventDefault();
    h = a.getAttribute('href');
    history.replaceState(null, '', h);
    v = new URLSearchParams(location.search).get('view');
    url = location.origin + location.pathname + (v ? '?view=' + v : '') + h;
    note = one('[data-faq-note]', a.parentNode);
    (navigator.clipboard ? navigator.clipboard.writeText(url).then(function () { return 1; }, function () { return legacy(url); }) : Promise.resolve(legacy(url)))
      .then(function (ok) {
        note.textContent = ok ? T.copied : T.ready;
        clearTimeout(note._t);
        note._t = setTimeout(function () { note.textContent = ''; }, 4000);
      });
  });

  /* Aktives Thema; mobil die aktive Themen-Pille in Sicht halten */
  if (window.IntersectionObserver && L.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) L.forEach(function (l) {
          var on = l.getAttribute('href') == '#' + en.target.id;
          l.setAttribute('aria-current', on);
          if (on && U.scrollWidth > U.clientWidth) U.scrollTo({ left: Math.max(0, l.parentNode.offsetLeft - 16), behavior: M ? 'auto' : 'smooth' });
        });
      });
    }, { rootMargin: '-25% 0px -65% 0px' });
    C.forEach(function (c) { io.observe(c); });
  }
})();
